import { defineStore } from "pinia";
import type { ReportConfig } from "types/shim";
import { presetsConfig } from "@/utils/const";

export const useReportConfigStore = defineStore("reportConfig", () => {
  const config = ref<ReportConfig>(cloneDeep(presetsConfig.default) as unknown as ReportConfig);
  async function setConfig(data: ReportConfig = {} as ReportConfig) {
    config.value = { ...data };
  }

  return { config, setConfig };
});
